// extracted by mini-css-extract-plugin
export default {"label":"ViewSettings_label__YxJpd","fuller":"ViewSettings_fuller__pOGmU","mkcol2":"ViewSettings_mkcol2__RHKkO","desc":"ViewSettings_desc__SIHbn"};